import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=77c58b06&scoped=true&"
import script from "./FormCard.vue?vue&type=script&lang=ts&"
export * from "./FormCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c58b06",
  null
  
)

export default component.exports